import { NotificationModel } from 'api/models';
import { useInView } from 'framer-motion';
import { CircularProgress } from 'library/loaders';
import TzDateFormatter from 'modules/shared/components/helpers/TzDateFormatter';
import { FC, useRef } from 'react';
import useNotificationClick from '../../hooks/useNotificationClick';
import useNotificationRead from '../../hooks/useNotificationRead';
import NotificationFooter from '../NotificationFooter/NotificationFooter';
import NotificationIcon from '../NotificationIcon/NotificationIcon';
import NotificationMessage from '../NotificationMessage/NotificationMessage';
import { NotificationTypeEnum } from 'api/enums';

interface NotificationRowProps {
    notification: NotificationModel;
    onClose: () => void;
}

const NotificationRow: FC<NotificationRowProps> = (props) => {
    const { notification, onClose } = props;

    const ref = useRef(null);
    const isInView = useInView(ref);

    useNotificationRead({ notification, isInView });

    const { isLoading, notificationClickHandler } = useNotificationClick({ notification, onClose });

    return (
        <div
            ref={ref}
            className={[
                'relative flex gap-3 px-4 py-4 cursor-pointer',
                !notification.read ? 'bg-primary/[0.03]' : '',
            ].join(' ')}
            onClick={notificationClickHandler}
        >
            <div>
                <NotificationIcon type={notification.type} createdBy={notification.createdBy} />
            </div>

            <div className="text-sm w-full pr-6 overflow-hidden">
                <div>
                    <NotificationMessage
                        message={
                            notification.type === NotificationTypeEnum.CUSTOM_PUSH_NOTIFICATION
                                ? notification.details.title
                                : notification.message
                        }
                    />
                </div>
                <div className="text-xs text-grayscale-500 mt-1">
                    <TzDateFormatter date={notification.createdAt} format={'h:mm a [·] DD MMM, YYYY'} />{' '}
                </div>

                {isLoading ? (
                    <div className="flex absolute bottom-3 right-3 text-primary">
                        <CircularProgress size={20} />
                    </div>
                ) : (
                    ''
                )}
                <div className="relative flex items-center">
                    <NotificationFooter
                        type={notification.type}
                        details={
                            notification.type === NotificationTypeEnum.CUSTOM_PUSH_NOTIFICATION
                                ? notification.message
                                : notification.details
                        }
                    />
                </div>
            </div>

            {!notification.read && <div className="absolute top-4 right-4 w-2 h-2 bg-primary rounded-full"></div>}
        </div>
    );
};

export default NotificationRow;
